import React from 'react';
import PropTypes from 'prop-types';

import {OECustomCheckbox} from '../../controls/oe-checkbox';
import OEObjectModelValueCell from './oe-object-model-value-cell';

export default class OEObjectModelBoolValueCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.value = this.props.allowUndefined ? this.props.value : !!this.props.value;

        this.lastDefinedValue = !!this.props.value;

        this.state = {
            value: this.value,
            lastDefinedValue: this.lastDefinedValue
        };

        this.onDefinedPressed = this.onDefinedPressed.bind(this);
        this.onValuePressed = this.onValuePressed.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        if(this.props.value !== nextProps.value) {
            let value = nextProps.allowUndefined ? nextProps.value : !!nextProps.value;
            if(value != this.value) {
                this.value = value;
                this.onValueChanged(false);
            }
        } else {
            if(this.props.allowUndefined !== nextProps.allowUndefined) {
                if(nextProps.allowUndefined && nextProps.value == undefined && this.value != undefined)    {
                    this.value = undefined;
                    this.onValueChanged();
                }
                if(!nextProps.allowUndefined && this.value == undefined)    {
                    this.value = this.lastDefinedValue;
                    this.onValueChanged();
                }
            }
        }
    }

    onValueChanged(callback = true)    {
        if(this.value !== undefined && this.lastDefinedValue !== this.value)    {
            this.lastDefinedValue = this.value;
            this.setState({lastDefinedValue: this.lastDefinedValue});
        }
        this.setState({value: this.value});
        if(callback && this.props.onChange) this.props.onChange(this, this.props.name, this.value);
    }

    render()    {
        return (
            <OEObjectModelValueCell {...this.props}>
                {!this.props.allowUndefined ? null :
                    <OECustomCheckbox
                        className="checkbox-defined"
                        disabled={this.props.disabled}
                        checked={this.props.value !== undefined}
                        onPressed={this.onDefinedPressed}
                    />
                }

                <OECustomCheckbox
                    className="checkbox-value"
                    disabled={this.props.disabled || (this.props.allowUndefined && this.state.value === undefined)}
                    checked={this.state.lastDefinedValue}
                    onPressed={this.onValuePressed}
                /> 
            </OEObjectModelValueCell>
        );
    }

    onDefinedPressed(sender)    {
        let value = this.value !== undefined ? undefined : this.lastDefinedValue;
        if(value === undefined && !this.props.allowUndefined)  return;
        this.value = value;
        this.onValueChanged();
    }

    onValuePressed(sender)    {
        this.value = !this.value;
        this.onValueChanged();
    }
};

OEObjectModelBoolValueCell.defaultProps = Object.assign({
    disabled:                   false,
    allowUndefined:             false,
}, OEObjectModelValueCell.defaultProps);

OEObjectModelBoolValueCell.propTypes = Object.assign({
    disabled:                   PropTypes.bool,
    allowUndefined:             PropTypes.bool,
    value:                      PropTypes.bool
}, OEObjectModelValueCell.propTypes);